export const GET_REPORT = 'GET_REPORT';
export const SET_SME_REPORT = 'SET_SME_REPORT';
export const RESET_REPORTS = 'RESET_REPORTS';


